import React from 'react';
import { FaCheckCircle } from '@react-icons/all-files/fa/FaCheckCircle';
import { FaTimesCircle }  from '@react-icons/all-files/fa/FaTimesCircle';

export interface BooleanCellProps {
  /** The boolean value to display */
  value?: boolean | null;
  /** Color for the true (checked) icon — default green */
  trueColor?: string;
  /** Color for the false (times) icon — default red */
  falseColor?: string;
  /** Icon size in px — default 16 */
  size?: number;
  /** Show a label beside the icon */
  showLabel?: boolean;
  /** Label text when true — default 'Sí' */
  trueLabel?: string;
  /** Label text when false — default 'No' */
  falseLabel?: string;
}

export default function BooleanCell({
  value,
  trueColor  = '#22c55e',
  falseColor = '#ef4444',
  size       = 16,
  showLabel  = false,
  trueLabel  = 'Sí',
  falseLabel = 'No',
}: BooleanCellProps) {
  const isTrue = !!value;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
      {isTrue
        ? <FaCheckCircle style={{ color: trueColor,  fontSize: size, flexShrink: 0 }} />
        : <FaTimesCircle style={{ color: falseColor, fontSize: size, flexShrink: 0 }} />
      }
      {showLabel && (
        <span style={{ fontSize: 12, fontWeight: 600, color: isTrue ? trueColor : falseColor }}>
          {isTrue ? trueLabel : falseLabel}
        </span>
      )}
    </span>
  );
}
